import script from "./ContactForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactForm.vue?vue&type=script&setup=true&lang=ts"

import "./ContactForm.vue?vue&type=style&index=0&id=18f9e1e4&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f9e1e4"]])

export default __exports__